import { AxiosAdapter } from 'axios'
import LRUCache from 'lru-cache'
import { lxMV } from '../../lx'
import { CustomRequestConfig } from '../types'
import buildSortedURL, { genParams } from './buildSortedURL'

interface CACHE_VALUE {
  timestamp: number
  value?: any
}

export default function throttleAdapterEnhancer(
  adapter: AxiosAdapter,
  options?: {
    threshold?: number
    cache?: LRUCache<string, CACHE_VALUE>
  },
): AxiosAdapter {
  const { threshold = 1000, cache = new LRUCache<string, CACHE_VALUE>({ max: 10 }) } = options || {}

  const recordCacheWithRequest = (index: string, config: CustomRequestConfig) => {
    const responsePromise = (async () => {
      try {
        const response = await adapter(config)
        cache.set(index, {
          timestamp: Date.now(),
          value: Promise.resolve(response),
        })
        return response
      } catch (reason) {
        cache.del(index)
        throw reason
      }
    })()

    cache.set(index, {
      timestamp: Date.now(),
      value: responsePromise,
    })

    return responsePromise
  }

  return (config: CustomRequestConfig) => {
    const { url = '', method, params, data, paramsSerializer, throttle } = config
    if (throttle) {
      const index = buildSortedURL(url, genParams(data, params), paramsSerializer)
      const now = Date.now()
      const cachedRecord: CACHE_VALUE = cache.get(index) || { timestamp: now }
      console.log(index, cachedRecord)
      if (method === 'get' || method === 'post') {
        if (now - cachedRecord.timestamp <= threshold) {
          const responsePromise = cachedRecord.value
          if (responsePromise) {
            lxMV('b_airbnb_0zzvskcs_mv', {
              custom: {
                title: index,
              },
            })
            return responsePromise
          }
        }
        return recordCacheWithRequest(index, config)
      }
    }

    return adapter(config)
  }
}
